<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                text
            >
                <v-icon left size="medium">mdi-lock</v-icon>
                {{ $t('user.password_reset') }}
            </v-btn>
        </template>

        <UserPasswordForm
            @settingsIsProcessed="done"
            @settingsIsCanceled="close"
        ></UserPasswordForm>
    </v-dialog>
</template>

<script>
  import UserPasswordForm from './UserPasswordForm'

  export default {
    name: 'UserPasswordFormDialog',
    components: { UserPasswordForm },
    data: () => ({
      dialog: false
    }),
    methods: {
      done () {
        this.dialog = false
      },
      close () {
        this.dialog = false
      }
    }
  }
</script>
